import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'nullhandling'
})
export class NullhandlingPipe implements PipeTransform {
  transform(value: any): string {
    if (!value) {
      return '';
    }
    return value;
  }

}
